import { render, staticRenderFns } from "./collapse-element.vue?vue&type=template&id=5e22a4a0&scoped=true"
import script from "./collapse-element.vue?vue&type=script&lang=js"
export * from "./collapse-element.vue?vue&type=script&lang=js"
import style0 from "./collapse-element.vue?vue&type=style&index=0&id=5e22a4a0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e22a4a0",
  null
  
)

export default component.exports